import {SwiperElementType, SwiperOptions} from "./SwiperTypes";

// Standard Klasse fuer alle Redesign Swiper (Swiper Element/WebComponent, in XSL erstellt))
class SwiperElement {
  // Basic params
  private static paramsBasic: SwiperOptions = {
    lazyPreloadPrevNext: 1,
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    simulateTouch: true,
    mousewheel: {forceToAxis: true},
  };

  public static run(swiperSection: HTMLElement, params: SwiperOptions): SwiperElementType | undefined {
    const swiperElement = swiperSection.querySelector<SwiperElementType>("swiper-container");
    if (!swiperElement) {
      return;
    }

    const slides = swiperElement.querySelectorAll<HTMLElement>("swiper-slide");
    if (!slides.length) {
      return;
    }

    Object.assign(swiperElement, SwiperElement.paramsBasic, params);
    swiperElement.initialize();

    return swiperElement;
  }
}

export default SwiperElement;
